import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ConferencePage from './pages/conference/conference'
import HomePage from './pages/home/home';
import { routes } from './utils/routes';
import NewConferencePage from './pages/conference-new/conference-new';
import PrivacyPolicyPage from './pages/privacy-policy/privacy-policy';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={routes.HOME} element={<HomePage />}/>
          <Route path={routes.REGISTER} element={<NewConferencePage />}/>
          <Route path={routes.PRIVACY_POLICY} element={<PrivacyPolicyPage />}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
